(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jib-tee-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-jib-tee]').forEach((section) => {
    const variantDataNode = section.querySelector('[data-variant-data]');
    const form = section.querySelector('form[action*="/cart/add"]');
    const variantInput = section.querySelector('[data-variant-id]');
    const optionInputs = Array.from(section.querySelectorAll('[data-option-input]'));
    const optionGroups = Array.from(section.querySelectorAll('[data-option-position]'));
    const addButton = section.querySelector('[data-testid="jib-tee-add-to-cart"]');
    const addLabel = section.querySelector('[data-add-label]');
    const priceNodes = section.querySelectorAll('[data-price], [data-button-price], [data-sticky-price]');
    const stickyBar = section.querySelector('[data-sticky-bar]');
    const stickyButton = section.querySelector('[data-sticky-submit]');
    const availability = section.querySelector('[data-availability]');
    const availabilityLabel = section.querySelector('[data-availability-label]');
    const dialog = section.querySelector('[data-size-guide-dialog]');
    const sizeGuideButtons = section.querySelectorAll('[data-size-guide-open]');

    if (!variantDataNode || !form || !variantInput) return;

    const variantMap = JSON.parse(variantDataNode.textContent);
    const variants = Object.values(variantMap);
    const addText = section.dataset.addText || '';
    const soldOutText = section.dataset.soldOutText || '';
    const availableText = section.dataset.availableText || '';

    const selectedOptions = () => {
      return optionGroups.map((group) => {
        const checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : '';
      });
    };

    const updateOptionAvailability = () => {
      const selected = selectedOptions();

      optionGroups.forEach((group, groupIndex) => {
        group.querySelectorAll('[data-option-input]').forEach((input) => {
          const candidate = [...selected];
          candidate[groupIndex] = input.value;
          input.disabled = !variants.some(
            (item) => item.available && item.options.every((value, index) => value === candidate[index])
          );
        });
      });
    };

    const updatePurchaseState = (variant) => {
      const canPurchase = Boolean(variant && variant.available);

      if (addButton) addButton.disabled = !canPurchase;
      if (stickyButton) stickyButton.disabled = !canPurchase;
      if (addLabel) addLabel.textContent = canPurchase ? addText : soldOutText;
      if (stickyButton) stickyButton.textContent = canPurchase ? addText : soldOutText;
      if (availability) availability.classList.toggle('is-unavailable', !canPurchase);
      if (availabilityLabel) availabilityLabel.textContent = canPurchase ? availableText : soldOutText;
    };

    const syncVariantMedia = (variant) => {
      if (!variant?.media_id || !window.matchMedia('(max-width: 989px)').matches) return;

      const target = section.querySelector(`[data-media-id="${variant.media_id}"]`);
      if (!target) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center',
      });
    };

    const setVariant = (shouldSyncMedia = true) => {
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));

      if (!variant) {
        updatePurchaseState(null);
        updateOptionAvailability();
        return;
      }

      variantInput.value = variant.id;
      priceNodes.forEach((node) => {
        node.textContent = variant.price;
      });

      updatePurchaseState(variant);
      updateOptionAvailability();
      if (shouldSyncMedia) syncVariantMedia(variant);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionInputs.forEach((input) => input.addEventListener('change', () => setVariant(true)));

    sizeGuideButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      });
    });

    if (stickyButton) {
      stickyButton.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else if (addButton) {
          addButton.click();
        }
      });
    }

    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        },
        { threshold: 0.2 }
      );
      observer.observe(addButton);
    }

    setVariant(false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
